import isEmpty from 'lodash.isempty';
import { serializeDocument } from 'anodum';
import site from '../../site';
import template from '../../template';
import hdrm from '../../hdrm';
import getGlobal from '../selectors/global';
import saveGlobals from '../helpers/save-globals';
import ejectGlobals from '../helpers/eject-globals';
import constants from '../constants';

const { globalIds } = constants;

const updateGlobalHtmlBySettings = (store) => (next) => (action) => {
  switch (action.type) {
    case site.actionTypes.UPDATE_SETTINGS: {
      const state = store.getState();
      const variables = template.selectors.getVariables(state);
      const socialIcons = template.selectors.getSocialIcons(state);
      const activePageId = site.selectors.getActivePageId(state);
      const activePage = site.selectors.getPage(state, activePageId);
      const { settings, updateGlobals, updateCopyrightGlobal } = action.payload;

      if (!updateGlobals || !settings || isEmpty(variables)) {
        next(action);
        return;
      }

      const globalsToUpdate = [];

      Object.keys(settings).forEach((setting) => {
        if (!variables[setting]) return;

        const settingValue = settings[setting];

        variables[setting].forEach((variable) => {
          const global = getGlobal(state, variable.globalId);
          if (!global || (global.id === globalIds.COPYRIGHT && !updateCopyrightGlobal)) return;
          const { html, id } = global;
          const newHTML = site.helpers.injectSiteSettings({
            variable,
            settingValue,
            setting,
            html,
            socialIcons,
          });

          globalsToUpdate.push({ id, newHTML });
        });
      });

      saveGlobals(globalsToUpdate);

      const staticDOM = hdrm.instance.driver.getStaticDocument();
      if (activePageId && activePage.html && staticDOM) {
        const newHTML = serializeDocument(ejectGlobals(staticDOM));

        store.dispatch(site.actions.setPageHTML(activePageId, newHTML));
      }

      next(action);
      break;
    }

    default:
      next(action);
  }
};

export default updateGlobalHtmlBySettings;
